document.addEventListener('DOMContentLoaded', function() {
  
  document.querySelector('body').addEventListener('click',function(event){
    let targetElement = event.target
    let selector = '.transformer-tabs li a';
    while(targetElement != null) {
      if(targetElement.matches(selector)) {
       event.preventDefault();
       displayTabs(targetElement)
       return;
      }
      targetElement = targetElement.parentElement;
   }
  },true);

  function displayTabs(target) {
    const targetContent = target.getAttribute('href');
    const tabLinks = document.querySelectorAll('.transformer-tabs li a');
    const tabs = document.querySelectorAll('.tabs > div');

    tabLinks.forEach((link) => {
      if (link.getAttribute('href') !== targetContent) {
        link.classList.add('active');
        link.classList.remove('active');
      }
      else {
        link.classList.remove('active');
        link.classList.add('active');
      }
    });
    tabs.forEach((content) => {
      if (content.getAttribute('id') !== targetContent.substring(1)) {
        content.setAttribute('active', false);
      }
      else {
        content.setAttribute('active', true);
      }
    });
  }

});
